import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
`;

export const TooltipWrapper = styled.div`
  margin-right: 32px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
`;
